import { Shell } from "@/components/Shell";
import { LayoutDashboard, Users, ArrowDownToLine, ArrowUpFromLine, Receipt, History, ShieldAlert } from "lucide-react";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/deposits", label: "Deposits", icon: ArrowDownToLine },
  { to: "/admin/withdrawals", label: "Withdrawals", icon: ArrowUpFromLine },
  { to: "/admin/transactions", label: "Transactions", icon: Receipt },
  { to: "/admin/disputes", label: "Disputes", icon: ShieldAlert },
  { to: "/admin/activity", label: "Activity Log", icon: History },
];

export default function AdminLayout() {
  return <Shell items={items} tag="Admin Control" />;
}
